import React from "react"

import { withObserver } from "~contexts/ObserverContext"

import * as style from "./Observe.module.scss"

const Observe = ({
  option = "",
  value = "",
  events = {},
  lazy = false,
  unset = false,
  children,
}) => {
  const allowedvalues = value.split(",")

  unset = [true, "true", ""].includes(unset)

  const optionTriggered = events && events.hasOwnProperty(option)
  const triggered = optionTriggered && allowedvalues.includes(events[option])

  lazy = [true, "true", ""].includes(lazy)

  return (
    <div
      className={style.observe}
      data-triggered={triggered}
      data-option-triggered={optionTriggered}
      data-unset={unset}
    >
      {(!lazy || triggered) && children}
    </div>
  )
}

export default withObserver(Observe)
